<template>
        <div>
            <p class="border-solid border-1 border-grey-light rounded p-3 overflow-y-scroll">
                {{ text }}
            </p>
            <div class="flex flex-col sm:flex-row sm:flex-wrap sm:items-center mt-4 gap-2">
                <vs-button
                    v-clipboard:copy="text"
                    class="copy-button xs:w-full sm:w-auto rounded-lg"
                >
                    {{ $t("copy-to-clipboard.button.title") }}
                </vs-button>
                <slot name="actions" />
            </div>
        </div>
</template>
<script>
export default {
    name: 'copy-to-clipboard',
    data() {
        return {
            uid:  (Math.random() + 1).toString(36).substring(7),
        }
    },
    props: {
        text: {
            type: String,
            required: true
        }
    }
}
</script>